import { render, staticRenderFns } from "./AppTransition.vue?vue&type=template&id=a2662070&"
import script from "./AppTransition.vue?vue&type=script&lang=js&"
export * from "./AppTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYReverseTransition})
